import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayoutComponent } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity, useLang } from '@shapeable/ui';
import { ValueBubble } from '../elements/value-bubble';
import { useSite } from '../../hooks/use-site';
import { BubbleStyles } from '../../theme';
import { MetricLayout } from '../entities/metric-layout';

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    justify-content: center;
  `,
});

const ValueStyles = breakpoints({
  base: css`
    ${BubbleStyles};
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MetricLayout)<ContainerProps>`${ContainerStyles}`,
    Value: styled(ValueBubble)`${ValueStyles}`,
};

export const BlockLayoutTotalFishBiomass: BlockLayoutComponent = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  const t = useLang();
  const { metrics } = useSite();
  const { totalFishBiomassPerYear } = metrics;

  return (
    <My.Container showContent entity={entity} className={className}>
      <My.Value value={totalFishBiomassPerYear} name={t('Fish Biomass')} unit={t('(tons)')} /> 
    </My.Container>
  )
};